import { createClient } from "next-sanity";

const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID;
const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET;
const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION || "2025-01-01";

export const sanityConfig = {
  projectId,
  dataset,
  apiVersion,
  useCdn: false
};

export const sanityClient =
  projectId && dataset
    ? createClient({
        projectId,
        dataset,
        apiVersion,
        useCdn: false
      })
    : null;

/**
 * Returns a client with stega encoding enabled so fetched strings carry
 * source-map metadata the VisualEditing overlay can use to open the right
 * Sanity field. Only used when Next.js draftMode is on.
 */
export const getStegaClient = () => {
  if (!sanityClient) return null;
  return sanityClient.withConfig({
    stega: {
      enabled: true,
      studioUrl: "/studio"
    }
  });
};
